(function () {
  window.initHoliday2026Lp = function () {
    var $ = window.jQuery;

    if (!$ || typeof $.fn.on !== 'function') {
      console.error('[LP] jQuery is required for initHoliday2026Lp');
      return;
    }

    function bindLoad(fn) {
      var run = function () {
        try {
          fn();
        } catch (e) {
          console.warn('[LP] initHoliday2026Lp bindLoad', e);
        }
      };

      if (document.readyState === 'complete') {
        run();
      } else {
        $(window).on('load', run);
      }
    }

    function safeTop(target) {
      try {
        var $el = target && target.jquery ? target : $(target);

        if (!$el || !$el.length) return 0;

        var o = $el.offset();

        return o ? o.top : 0;

      } catch (e) {
        return 0;
      }
    }


    /* --- block 1 --- */
    (function () {
      try {

        // =========================
        // Accordion
        // =========================
        $('.accordion__wrapper .accordion').on('click', function (e) {

          e.preventDefault();

          var $wrapper =
            $(this).closest('.accordion__wrapper');

          $wrapper.toggleClass('open');

          $wrapper
            .find('.accordion-more')
            .stop(true, true)
            .slideToggle(500);

        });

      } catch (e) {
        console.warn(
          '[LP] initHoliday2026Lp block 1',
          e
        );
      }
    })();


    /* --- block 2 --- */
    (function () {
      try {

        // =========================
        // Slider
        // =========================
        $(function () {

          $('.item-slider').each(function () {
            var $slider = $(this);
            var $list = $slider.find(
              '.new-item__list, .lineup__list, .other-lineup__list, .trial-gift__list'
            );

            var slidesToShow = $list.hasClass('new-item__list') ? 2 : 3;

            var spSlidesToShow = $list.hasClass('lineup__list') ? 1 : 2;

            $list.slick({
              slidesToShow: slidesToShow,
              slidesToScroll: 1,
              arrows: true,
              swipe: true,
              infinite: true,
              dots: true,
              autoplay: true,
              autoplaySpeed: 5000,

              responsive: [
                {
                  breakpoint: 960,
                  settings: {
                    slidesToShow: spSlidesToShow
                  }
                }
              ]
            });

            $slider.find('ul li .other-kit__catch').matchHeight();
            $slider.find('ul li .img').matchHeight();
            $slider.find('ul li .name-and-price').matchHeight();
          });

        });

      } catch (e) {
        console.warn(
          '[LP] initHoliday2026Lp block 2',
          e
        );
      }
    })();


    /* --- block 3 --- */
    (function () {
      try {

        $(function () {
          $("#rb1 .reason-more-btn a").click(function () {
            $('#rb1').addClass("open");
            $('#rb1 .reason-more-bg').hide();
            $('#rb1 .reason-more-btn').hide();
            $('#rb1 .reason-close-btn').show();
          });

          $("#rb1 .reason-close-btn a").click(function () {
            $('#rb1').removeClass("open");
            $('#rb1 .reason-close-btn').hide();
            $('#rb1 .reason-more-bg').show();
            $('#rb1 .reason-more-btn').show();
          });
        });

        // =========================
        // ページトップ表示
        // =========================
        $(window).on('load scroll', function () {
          var pl = $(this).scrollTop();
          if (pl == 0) {
            $(".pagetop").css("display", "none");
          } else {
            $(".pagetop").css("display", "block");
          }

        });
      } catch (e) {
        console.warn(
          '[LP] initHoliday2026Lp block 3',
          e
        );
      }
    })();

    /* --- block 4 --- */
    (function () {
      try {

        $(function () {

          // =========================
          // ギフト価格帯タブ切り替え
          // =========================
          $('.tab').on('click', function () {

            var $tab = $(this);
            var $tabArea = $tab.closest('.tab-area');
            var $panelArea = $tabArea.next('.panel-area');

            // タブのactive切り替え
            $tabArea.find('.tab').removeClass('active');
            $tab.addClass('active');

            // 対応するパネルのactive切り替え
            var index = $tab.index();
            var $panels = $panelArea.find('.price-block.panel');

            $panels.removeClass('active');
            var $targetPanel = $panels.eq(index);
            $targetPanel.addClass('active');

            // 表示されたスライダーの位置を再計算
            $targetPanel.find('.thumbs').each(function () {
              var $slider = $(this);

              if ($slider.hasClass('slick-initialized')) {
                $slider.slick('setPosition');
              }
            });

          });


          // =========================
          // ギフトスライダー共通設定
          // =========================
          $('.price-slide .thumbs').each(function () {

            var $slider = $(this);
            var $slideBlock = $slider.closest('.price-slide');

            // このスライダー専用の矢印を取得
            var $prev = $slideBlock.find('.gift-item-prev');
            var $next = $slideBlock.find('.gift-item-next');

            // 商品数
            var itemCount = $slider.find('li').length;

            // Slick初期化
            $slider.slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              arrows: true,
              swipe: true,
              infinite: true,
              dots: true,

              responsive: [{
                breakpoint: 960,
                settings: {
                  slidesToShow: 1,
                  centerMode: true,
                  centerPadding: '17vw',
                  infinite: true
                }
              }]
            });

            // =========================
            // 矢印の表示・非表示
            // =========================
            function updateArrows() {

              var isPC = $(window).width() > 960;

              if (isPC && itemCount <= 5) {
                // PC：商品が5つ以下なら矢印を非表示
                $prev.hide();
                $next.hide();
              } else {
                // PC：商品が6つ以上なら表示
                // SP：商品数に関係なく表示
                $prev.show();
                $next.show();
              }
            }

            updateArrows();

            // =========================
            // 矢印クリック
            // =========================
            $next.on('click', function () {
              $slider.slick('slickNext');
            });

            $prev.on('click', function () {
              $slider.slick('slickPrev');
            });

            // リサイズ時の矢印制御
            $(window).on('resize', updateArrows);

          });

        });

      } catch (e) {
        console.warn(
          '[LP] initHoliday2026Lp block 4',
          e
        );
      }
    })();


    /* inview: 動的読込後も表示する */
    (function () {
      try {

        var $els = $('.inview');

        if (!$els.length) return;

        $els.each(function () {

          var $el = $(this);

          if ($el.data('lpInviewBound')) return;

          $el.data('lpInviewBound', 1);

          $el.one(
            'inview',
            function (event, isInView) {

              if (isInView) {
                $(this)
                  .stop()
                  .animate({
                    opacity: 1
                  }, 500);
              }

            }
          );

        });

        $(window).trigger('scroll');

      } catch (e) { }

    })();

  };


  window.destroyMintySparkYuzuLp = function () {

    var $ = window.jQuery;

    if (!$) return;

    try {

      $('.slick-initialized').each(function () {
        $(this).slick('unslick');
      });

    } catch (e) { }


    try {

      document
        .querySelectorAll('.swiper')
        .forEach(function (el) {

          if (el.swiper) {
            el.swiper.destroy(true, true);
          }

        });

    } catch (e) { }


    $('.open-modal').off('click');

    $('.pagetop a').off('click');

  };

})();